export const ALREADY_SIGNED_IN_ERROR = 'LOGIN_BLOCKED:ALREADY_SIGNED_IN';

// BE #418: login ditolak (409) karena akun masih punya sesi aktif di device lain.
// Dideteksi lewat kode, bukan teks message.
export const getLoginBlockedError = error =>
  error?.response?.status === 409 &&
  error?.response?.data?.data?.code === 'ALREADY_SIGNED_IN'
    ? ALREADY_SIGNED_IN_ERROR
    : null;

const ERROR_MAP = [
  {
    match: /^LOGIN_BLOCKED:ALREADY_SIGNED_IN$/,
    message:
      'This account is already signed in on another device or browser. Only one active session is allowed per account. Please sign out from the other device and try again.',
  },
  // Force logout (Login.js ?reason=<code> → 'SESSION_END:<code>'). Paling atas: pola
  // generik 401|unauthorized|timeout di bawah bisa ikut cocok.
  {
    match: /^SESSION_END:IDLE_TIMEOUT$/,
    message: 'You have been logged out after 15 minutes of inactivity.',
  },
  {
    match: /^SESSION_END:SIGNED_IN_ELSEWHERE$/,
    message:
      'Your session has ended because this account signed in from another device or browser.',
  },
  {
    match: /^SESSION_END:SESSION_REPLACED$/,
    message:
      'You signed in again on this browser. Please continue with your latest session.',
  },
  {
    match: /^SESSION_END:SESSION_EXPIRED$/,
    message: 'Your session has expired. Please sign in again.',
  },
  {
    match: /^SESSION_END:/,
    message: 'Your session has ended. Please sign in again.',
  },
  // Pesan spesifik dari BE (AccountController login / login-oidc) — harus di atas
  // matcher generik supaya tidak tertimpa.
  {
    match: /must login via IDAMAN/i,
    message:
      'This account uses idAMan. Please sign in with the idAMan button instead of a password.',
  },
  {
    match: /not registered in the application|user not found in database/i,
    message:
      'Your idAMan account is not registered in Hydro yet. Please contact the administrator to get access.',
  },
  {
    match: /must login with username and password/i,
    message:
      'This account is not an idAMan account. Please sign in with your username and password.',
  },
  {
    match: /invalid idaman token|email claim missing/i,
    message:
      'Your idAMan session is invalid or has expired. Please sign in with idAMan again.',
  },
  {
    match: /account is locked/i,
    message: 'Your account is locked. Please contact the administrator.',
  },
  {
    match:
      /401|403|unauthorized|invalid.*credential|incorrect.*password|invalid username|password incorrect/i,
    message: 'Invalid username or password. Please check your credentials.',
  },
  {
    match: /network error|failed to fetch|timeout|econnrefused/i,
    message: 'Unable to reach the server. Check your connection and try again.',
  },
  {
    match: /oidc|identity provider|redirect.*failed/i,
    message: 'idAMan authentication could not be started. Please try again.',
  },
  {
    match: /500|502|503|server/i,
    message: 'The server encountered an error. Please try again shortly.',
  },
];

export const extractLoginError = error => {
  if (!error) return '';

  if (typeof error === 'string') return error;

  if (typeof error === 'object') {
    if (error.message && typeof error.message === 'string')
      return error.message;
    if (error.data) {
      if (typeof error.data === 'string') return error.data;
      if (error.data?.message) return error.data.message;
    }
  }

  return String(error);
};

export const getLoginErrorTitle = error => {
  const raw = extractLoginError(error);
  if (raw === ALREADY_SIGNED_IN_ERROR) return 'Account already in use';
  if (raw.startsWith('SESSION_END:')) return 'Signed out';
  return 'Unable to sign in';
};

export const formatLoginError = error => {
  const raw = extractLoginError(error).trim();
  if (!raw) return 'Something went wrong. Please try again.';

  const mapped = ERROR_MAP.find(({ match }) => match.test(raw));
  return mapped ? mapped.message : raw;
};
